import React, { useEffect, useRef, useState } from 'react';
import '../styles/MatchView.css';

function AnimatedScore({ value, animate = true }) {
  const [displayValue, setDisplayValue] = useState(value);
  const [offset, setOffset] = useState(0);
  const [animating, setAnimating] = useState(false);
  const prevValue = useRef(value);
  const animationQueue = useRef([]);
  const isProcessing = useRef(false);

  const processAnimationQueue = () => {
    if (isProcessing.current || animationQueue.current.length === 0) return;
    
    isProcessing.current = true;
    const nextValue = animationQueue.current.shift();
    
    const direction = nextValue > displayValue ? -1 : 1;
    setOffset(direction);
    setAnimating(true);

    setTimeout(() => {
      setAnimating(false);
      setDisplayValue(nextValue);
      setOffset(0);
      isProcessing.current = false;
      
      // Process next in queue immediately (no delay)
      if (animationQueue.current.length > 0) {
        processAnimationQueue();
      }
    }, 150); // Slightly faster animation
  };

  useEffect(() => {
    if (value === prevValue.current) return;

    if (!animate) {
      // Just snap to the new value without animation
      setDisplayValue(value);
      prevValue.current = value;
      setOffset(0);
      setAnimating(false);
      animationQueue.current = [];
      isProcessing.current = false;
      return;
    }

    // Add to animation queue
    animationQueue.current.push(value);
    prevValue.current = value;
    
    // Start processing if not already
    if (!isProcessing.current) {
      processAnimationQueue();
    }
  }, [value, animate, displayValue]);

  return (
    <div className="score">
      <div
        className="score-inner"
        style={{
          transform: `translateY(${offset * 1}em)`,
          transition: animating ? 'transform 200ms cubic-bezier(.25,.46,.45,.94)' : 'none',
        }}
      >
        <div className="score-number">{displayValue - 1}</div>
        <div className="score-number">{displayValue}</div>
        <div className="score-number">{displayValue + 1}</div>
      </div>
    </div>
  );
}

export default AnimatedScore;
